export const avatars_per_course = 4;
export const avatars_per_query = 1000;
